import React, {useEffect, useRef, useState} from 'react'
import {InputText} from 'primereact/inputtext'
import {FileUploadeComponent} from '../../../shared/FileUploaderComponent/FileUploadeComponent'
import ButtonComponent from '../../../shared/ButtonComponent/ButtonComponent'
import {
  createOrUpdateAddress,
  createOrUpdateCompany,
  fetchCompany,
  fetchCompanyAddresses,
  getCompany,
  getCompanyAddresses,
  getEditAddress,
  getMsgType,
  getSelectedCompany,
  setEditAddress,
  setSelectedAddress,
  setSelectedCompany,
} from '../../slice/company.slice'
import {useAppDispatch, useAppSelector} from '../../../../hooks'
import {Button} from 'primereact/button'
import {Image} from 'primereact/image'
import _ from 'lodash'
import {Toast} from 'primereact/toast'
import {TabPanel, TabView} from 'primereact/tabview'
import AddressesComponent from '../../../shared/AddressesComponent/Addresses.Component'
import AddressDetail from '../AddressDetail/AddressDetail'
import {OlangItem} from '../../../shared/Olang/user-interface/OlangItem/OlangItem'
import {setToastParams} from '../../../../store/slices/ui.slice'
import {API_BASE_URL_IMAGE} from '../../../../api/config'
import {Card} from 'primereact/card'
import {Calendar} from 'primereact/calendar'
import { PageHeader } from '../../../shared/PageHeader/PageHeader'

const CompanyList = () => {
  let company = useAppSelector(getSelectedCompany)
  let companyAddresses = useAppSelector(getCompanyAddresses)
  let msgType = useAppSelector(getMsgType)
  let editAddress = useAppSelector(getEditAddress)

  const dispatch = useAppDispatch()

  const [imageChange, setImageChange] = useState(false)
  const [msg, setMsg] = useState(false)
  const messagesRef = useRef(null)
  const toast = useRef(null)

  const onInputChange = (e) => {
    let old = _.cloneDeep(company)
    old = {
      ...old,
      [e.target.name]: e.target.value,
    }
    dispatch(setSelectedCompany(old))
  }

  const save = () => {
    dispatch(createOrUpdateCompany(company)).then((res) => {
      if (res.payload) {
        dispatch(
          setToastParams({
            show: true,
            severity: 'success',
            summary: 'SUCCESS',
            detail: 'Informations sauvegardées avec succès',
          })
        )
        setImageChange(false)
        dispatch(fetchCompany())
      }
    })
  }

  const saveAddressCompany = (e) => {
    console.log('saveAddressCompany', e)
    dispatch(setSelectedAddress(e))
    dispatch(createOrUpdateAddress(e)).then((res) => {
      console.log(' w res', res)
      if (res.payload) {
        dispatch(fetchCompanyAddresses())
        dispatch(setEditAddress(false))
        dispatch(setSelectedAddress(null))
      }
    })
  }

  useEffect(() => {
    if (msg) {
      messagesRef.current.show({
        severity: 'success',
        summary: 'Success Message',
        detail: `${msgType}`,
        life: 3000,
        closable: true,
      })
    }
  }, [msg])

  useEffect(() => {
    dispatch(fetchCompany())
    dispatch(fetchCompanyAddresses())
  }, [])

  return (
    <>
      <Toast ref={toast} />
      
      {/* Page Header */}
      <PageHeader
        titleOlang="company.info"
        backPath="/dashboard"
        info={
          <div className="flex align-items-center gap-3">
            {company?.name && (
              <div className="flex align-items-center gap-2">
                <i className="pi pi-building text-xl text-primary"></i>
                <span className="text-lg font-semibold">{company.name}</span>
              </div>
            )}
          </div>
        }
        className="m-3"
      />
      
      <TabView>
        <TabPanel header={<OlangItem olang='Reception' />}>
          <Card
            className='lg:w-6 w-full md:w-6 '
            style={{
              boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
              borderRadius: '15px',
            }}
          >
            <div className='p-2  flex flex-column'>
              <div className='flex flex-column'>
                {imageChange ? (
                  <div className='w-11'>
                    <div className='flex justify-content-end'>
                      <i
                        className='pi pi-times cursor-pointer'
                        onClick={() => setImageChange(!imageChange)}
                      ></i>
                    </div>

                    <FileUploadeComponent
                      accept={'image/*'}
                      // onUploadFinished={onFinishedUpload}
                      uploadExtraInfo={{
                        src: 'company',
                        srcID: company?.id || 0,
                        id: company?.imageid || 0,
                        desc: 'profile',
                      }}
                    />
                  </div>
                ) : (
                  <div className='w-5 flex flex-column '>
                    <div className='ml-5'>
                      <Button
                        icon='pi pi-pencil'
                        className='ml-8 h-2rem w-2rem '
                        rounded
                        severity='secondary'
                        aria-label='User'
                        onClick={() => setImageChange(!imageChange)}
                      />
                    </div>
                    <div>
                      {company?.image ? (
                        <Image
                          src={`${API_BASE_URL_IMAGE}${company?.image}`}
                          alt='Image'
                          width='100'
                          preview
                          imageStyle={{objectFit: 'cover', borderRadius: '10px'}}
                          onError={(e) => {
                            e.target.style.display = 'none'
                            e.target.parentElement.innerHTML = `
                              <div class="flex align-items-center justify-content-center rounded bg-gray-200" style="width: 100px; height: 100px; border-radius: 10px;">
                                <i class="fas fa-building text-gray-500" style="font-size: 32px;"></i>
                              </div>
                            `
                          }}
                        />
                      ) : (
                        <div 
                          className='flex align-items-center justify-content-center rounded bg-gray-200'
                          style={{width: '100px', height: '100px', borderRadius: '10px'}}
                        >
                          <i className="fas fa-building text-gray-500" style={{fontSize: '32px'}}></i>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div className='flex flex-column my-3'>
                <label className=''>
                  <OlangItem olang='Code' />
                </label>
                <InputText
                  name='code'
                  className='w-11 font-semibold text-lg'
                  value={company?.code}
                  onChange={onInputChange}
                />
              </div>
              <div className='flex flex-column my-3'>
                <label className=''>
                  <OlangItem olang='Label' />
                </label>
                <InputText
                  type='text'
                  name='label'
                  className='w-11 font-semibold text-lg'
                  value={company?.label}
                  onChange={onInputChange}
                />
              </div>
              <div className='flex flex-column my-3'>
                <label className=''>
                  <OlangItem olang='IDE' />
                </label>
                <InputText
                  type='text'
                  name='NPA'
                  className='w-11 font-semibold text-lg'
                  value={company?.NPA}
                  onChange={onInputChange}
                />
              </div>
              <div className='flex flex-column my-3'>
                <label className=''>
                  <OlangItem olang='Date.From' />
                </label>
                <Calendar
                  className='w-11 font-semibold text-lg'
                  value={company?.begDate}
                  onChange={onInputChange}
                  timeOnly
                  showIcon
                  icon={() => <i className='pi pi-clock' />}
                />
              </div>
              <div className='flex flex-column my-3'>
                <label className=''>
                  <OlangItem olang='Date.To' />
                </label>
                <Calendar
                  className='w-11 font-semibold text-lg'
                  value={company?.endDate}
                  onChange={onInputChange}
                  timeOnly
                  showIcon
                  icon={() => <i className='pi pi-clock' />}
                />
              </div>
              <div className='flex justify-content-end w-11 mt-6 my-5'>
                <ButtonComponent onClick={save} className='w-10rem flex justify-content-center'>
                  <OlangItem olang='Save' />
                </ButtonComponent>
              </div>
            </div>
          </Card>
        </TabPanel>
        <TabPanel header={<OlangItem olang='Addresses' />} leftIcon='pi pi-map mr-2'>
          <div>
            {editAddress == true ? (
              <AddressDetail handleSaveAddress={(e) => saveAddressCompany(e)} />
            ) : (
              <div className='flex flex-wrap lg:ml-8 w-full'>
                {companyAddresses?.map((address) => (
                  <AddressesComponent
                    key={address.id}
                    className='w-full lg:w-6 mt-4'
                    id={address.id}
                    type={address.type}
                    {...address}
                  />
                ))}
              </div>
            )}
          </div>
        </TabPanel>
      </TabView>
    </>
  )
}

export default CompanyList
